'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _map3 = require('lodash/map');

var _map4 = _interopRequireDefault(_map3);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _project = require('redux/modules/project');

var projectActions = _interopRequireWildcard(_project);

var _reactI18next = require('react-i18next');

var _components = require('components');

var _strings = require('helpers/strings');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var MediaList = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    deleteMediaActionData: state.project.deleteMediaActionData,
    deleteMediaLoading: state.project.deleteMediaLoading,
    editMediaActionData: state.project.editMediaActionData,
    editMediaLoading: state.project.editMediaLoading,
    mediaList: state.project.mediaListData,
    mediaListLoading: state.project.mediaListLoading,
    updateMediaOrderLoading: state.project.updateMediaOrderLoading
  };
}, (0, _extends3.default)({}, projectActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(MediaList, _Component);

  function MediaList() {
    (0, _classCallCheck3.default)(this, MediaList);
    return (0, _possibleConstructorReturn3.default)(this, (MediaList.__proto__ || (0, _getPrototypeOf2.default)(MediaList)).apply(this, arguments));
  }

  (0, _createClass3.default)(MediaList, [{
    key: 'onMove',
    value: function onMove(dragIndex, hoverIndex) {
      var resortMediaList = this.props.resortMediaList;

      resortMediaList(dragIndex, hoverIndex);
    }
  }, {
    key: 'onDrop',
    value: function onDrop() {
      var _props = this.props,
          updateMediaOrder = _props.updateMediaOrder,
          mediaList = _props.mediaList,
          projectId = _props.projectId;

      var ids = (0, _map4.default)(mediaList, 'id');
      return updateMediaOrder(projectId, ids);
    }
  }, {
    key: 'getMediaListPopover',
    value: function getMediaListPopover(el) {
      if (el) {
        this.mediaListPopover = el.getWrappedInstance().getWrappedInstance();
      }
    }
  }, {
    key: 'isMediaEdited',
    value: function isMediaEdited(id) {
      var _props2 = this.props,
          deleteMediaLoading = _props2.deleteMediaLoading,
          deleteMediaActionData = _props2.deleteMediaActionData,
          editMediaLoading = _props2.editMediaLoading,
          editMediaActionData = _props2.editMediaActionData;

      return deleteMediaLoading && deleteMediaActionData.uploadId === id || editMediaLoading && editMediaActionData.uploadId === id;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          t = _props3.t,
          mediaList = _props3.mediaList,
          mediaListLoading = _props3.mediaListLoading,
          projectId = _props3.projectId,
          projectType = _props3.projectType,
          updateMediaOrderLoading = _props3.updateMediaOrderLoading,
          multipleBoxsets = _props3.multipleBoxsets,
          isLocked = _props3.isLocked,
          isStandardMode = _props3.isStandardMode,
          hideOwner = _props3.hideOwner,
          hideReplaceFile = _props3.hideReplaceFile,
          hideDelete = _props3.hideDelete,
          hideIsrc = _props3.hideIsrc,
          hidePackId = _props3.hidePackId;


      var hideDragHandler = false;
      var lockSort = isLocked || mediaList.length < 2;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'pos-rel' },
          _react2.default.createElement(
            _components.SortableList,
            { className: 'margin-bottom-20 no-select' },
            _react2.default.createElement(
              _components.ListItem,
              { fullWidth: true, isTitle: true },
              !hideDragHandler && _react2.default.createElement('div', null),
              multipleBoxsets && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'span',
                  { className: 'hidden-sm hidden-xs' },
                  t('Part')
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'visible-sm visible-xs' },
                  '#'
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                t('Artist')
              ),
              _react2.default.createElement(
                'div',
                null,
                t('File Name')
              ),
              !hideOwner && _react2.default.createElement(
                'div',
                null,
                t('Owner')
              ),
              _react2.default.createElement('div', null)
            ),
            mediaList.map(function (media, index) {
              return _react2.default.createElement(
                _components.SortableListItem,
                {
                  fullWidth: true,
                  hideDragHandler: hideDragHandler,
                  isLocked: lockSort,
                  key: media.id,
                  onMove: _this2.onMove,
                  onDrop: _this2.onDrop,
                  index: index,
                  id: media.id
                },
                multipleBoxsets && _react2.default.createElement(
                  'div',
                  null,
                  media.part
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  media.artist
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  media.filename,
                  !hideIsrc && _react2.default.createElement(
                    'span',
                    { className: 'hint small margin-left-10' },
                    media.isrc
                  )
                ),
                !hideOwner && _react2.default.createElement(
                  'div',
                  null,
                  (0, _strings.concat)(' ', media.name, media.surname)
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'moreCell' },
                  !isLocked && _react2.default.createElement('i', { className: 'more', onClick: function onClick(e) {
                      return _this2.mediaListPopover.toggle(e, media);
                    } }),
                  _this2.isMediaEdited(media.id) && _react2.default.createElement(_components.Loader, { small: true, mask: true })
                )
              );
            })
          ),
          (mediaListLoading || updateMediaOrderLoading) && _react2.default.createElement(_components.Loader, { mask: true })
        ),
        _react2.default.createElement(_components.MediaListPopover, {
          projectId: projectId,
          projectType: projectType,
          ref: this.getMediaListPopover,
          isStandardMode: isStandardMode,
          hideReplaceFile: hideReplaceFile,
          hideDelete: hideDelete,
          hideIsrc: hideIsrc,
          hidePackId: hidePackId
        })
      );
    }
  }]);
  return MediaList;
}(_react.Component), _class3.propTypes = {
  deleteMediaActionData: _propTypes2.default.object,
  deleteMediaLoading: _propTypes2.default.bool,
  editMediaActionData: _propTypes2.default.object,
  editMediaLoading: _propTypes2.default.bool,
  hideDelete: _propTypes2.default.bool,
  hideIsrc: _propTypes2.default.bool,
  hideOwner: _propTypes2.default.bool,
  hidePackId: _propTypes2.default.bool,
  hideReplaceFile: _propTypes2.default.bool,
  isLocked: _propTypes2.default.bool,
  isStandardMode: _propTypes2.default.bool,
  mediaList: _propTypes2.default.array,
  mediaListLoading: _propTypes2.default.bool,
  multipleBoxsets: _propTypes2.default.bool,
  projectId: _propTypes2.default.number.isRequired,
  projectType: _propTypes2.default.string.isRequired,
  resortMediaList: _propTypes2.default.func,
  t: _propTypes2.default.func,
  updateMediaOrder: _propTypes2.default.func,
  updateMediaOrderLoading: _propTypes2.default.bool
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onMove', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onMove'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onDrop', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onDrop'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'getMediaListPopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'getMediaListPopover'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = MediaList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Project/MediaList/MediaList.js
// module id = 2048
// module chunks = 1